const notableAlumni = [
	{
		name: 'Tejendra Saini',
		image: 'https://source.unsplash.com/1200x800/?person',
		socials: [],
		works: [
			'Founder of EPMOC',
		]
	},
	{
		name: "Akshat Mittal",
		image: "https://source.unsplash.com/1200x800/?person",
		socials: [
			{
				service: "Linkedin",
				username: "akshatmittal61",
			},
			{
				service: "Instagram",
				username: "akshatmittal61",
			},
			{
				service: "Mail",
				username: "akshatmittal2506@gmail.com",
			},
		],
		works: [
			"Organiser and Founder of Footprints 2.0",
			"Member of the Core Team of the 2019 edition of Footprints",
			"Organiser of the 2018 edition of Footprints",
			"Worked at editorial for Abhivyakti 2018",
		],
	},
	{
		name: "Akshat Mittal",
		image: "https://source.unsplash.com/1200x800/?boy",
		socials: [
			{
				service: "Linkedin",
				username: "akshatmittal61",
			},
			{
				service: "Instagram",
				username: "akshatmittal61",
			},
			{
				service: "Mail",
				username: "akshatmittal2506@gmail.com",
			},
		],
		works: [
			"Organiser and Founder of Footprints 2.0",
			"Member of the Core Team of the 2019 edition of Footprints",
			"Organiser of the 2018 edition of Footprints",
			"Worked at editorial for Abhivyakti 2018",
		],
	},
];

export default notableAlumni;
